import { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Box } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import SidebarLayout from '../../layouts/SidebarLayout';
import { RootState } from '../../store';
import SSNPatientInputField from './components/SSNPatientInputField';
import CustomBottomButtonGroup from '../../components/UI/CustomBottomButtonGroup/CustomBottomButtonGroup';
import ConfirmAppointmentDialog from './components/ConfirmAppointmentDialog';
import { loaderActions } from '../../store/loader';
import { Appointment, Patient, Specialty } from '../../../domain/entities';
import { useAppointmentService, useSpecialtyService } from '../../hooks';
import PatientGeneralData from '../Patients/components/PatientGeneralData/PatientGeneralData';

const ChoosePatient = () => {
  const SpecialtyService = useSpecialtyService();
  const AppointmentService = useAppointmentService();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const appointment = useSelector((state: RootState) => state.appointment);

  const isLoading = (state: boolean) => {
    dispatch(loaderActions.setLoading(state));
  };

  const [specialty, setSpecialty] = useState<Specialty>();
  const [patient, setPatient] = useState<Patient>();
  const [openDialog, setOpenDialog] = useState<boolean>(false);

  useEffect(() => {
    SpecialtyService.getOne(appointment.specialty.code)
      .then((specialty) => setSpecialty(specialty))
      .catch((e) => console.log(e));
  }, []);

  const selectPatientHandler = (patient: Patient | undefined) => setPatient(patient);

  const openDialogHandler = () => setOpenDialog(true);

  const closeDialogHandler = () => setOpenDialog(false);

  const createAppointmentHandler = () => {
    if (!patient) return;

    isLoading(true);
    closeDialogHandler();
    const newAppointment = mapAppointmentStateToDomain();

    AppointmentService.create(newAppointment)
      .then(() => navigate('/citas'))
      .catch((e) => console.log(e))
      .finally(() => isLoading(false));
  };

  const mapAppointmentStateToDomain = (): Appointment => {
    const thirtyMinutes = 30 * 60 * 1000;

    if (!patient) throw new Error('Patient not found');

    return {
      startDate: new Date(appointment.schedule.datetimeInMilliseconds),
      endDate: new Date(appointment.schedule.datetimeInMilliseconds + thirtyMinutes),
      patient: {
        id: patient.id ?? '',
        name: patient.name ?? ''
      },
      doctor: {
        id: appointment.doctor.id,
        name: appointment.doctor.name
      },
      specialty: {
        code: appointment.specialty.code,
        name: appointment.specialty.name,
        color: appointment.specialty.color
      }
    };
  };

  return (
    <SidebarLayout>
      <h4>Escoger Paciente</h4>
      <SSNPatientInputField onPatientSelected={selectPatientHandler} />
      {patient && <PatientGeneralData patient={patient} style={{ marginTop: '24px' }} />}
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'center',
          margin: 1,
          paddingTop: 3
        }}
      >
        <CustomBottomButtonGroup
          canContinue={patient !== undefined}
          onContinueClicked={openDialogHandler}
          isNavigation={false}
        />
      </Box>
      <ConfirmAppointmentDialog
        isOpen={openDialog}
        date={new Date(appointment.schedule.datetimeInMilliseconds)}
        doctorName={appointment.doctor.name}
        specialty={specialty}
        onClosedClicked={closeDialogHandler}
        onConfirmClicked={createAppointmentHandler}
      />
    </SidebarLayout>
  );
};

export default ChoosePatient;
